/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { permissionCheck } from '../../../../../app/helper-functions/PermissionCheck';
var user_create,user_update,user_delete,user_view, user_activity_log
var role_create,role_update,role_delete,role_view,role_activity_log
var application_create,application_update,application_delete,application_view,application_activity_log
var user_application_create,user_application_update,user_application_delete,user_application_view,user_application_activity_log;

const SidebarMenuMain = () => {
  const intl = useIntl()
  user_create = permissionCheck('user-create');
  user_update = permissionCheck('user-update');
  user_delete = permissionCheck('user-delete');
  user_view = permissionCheck('user-view');
  user_activity_log = permissionCheck('user-activity-log');
  role_create = permissionCheck('role-create');
  role_update = permissionCheck('role-update');
  role_delete = permissionCheck('role-delete');
  role_view = permissionCheck('role-view');
  role_activity_log = permissionCheck('role-activity-log');
  application_create = permissionCheck('application-create');
  application_update = permissionCheck('application-update');
  application_delete = permissionCheck('application-delete');
  application_view = permissionCheck('application-view');
  application_activity_log = permissionCheck('application-activity-log');
  user_application_create = permissionCheck('user-application-create');
  user_application_update = permissionCheck('user-application-update');
  user_application_delete = permissionCheck('user-application-delete');
  user_application_view = permissionCheck('user-application-view');
  user_application_activity_log = permissionCheck('user-application-activity-log');
  
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
       {application_create || application_activity_log || application_view ? (
      <SidebarMenuItemWithSub
      to='/applications'
      title='Applications'
      icon='frame'
      fontIcon='bi-person'
    >
      {
        application_create &&  <SidebarMenuItem to='/applications/add-application' title='Add Application' hasBullet={true} />
      }
      {
       application_view && <SidebarMenuItem to='/applications/applications-list' title='List of Applications' hasBullet={true} />
      }
      {
       application_view && <SidebarMenuItem to='/applications/applications-logs' title='Logs' hasBullet={true} />
      }
    </SidebarMenuItemWithSub>
       ):null}
{
  user_create || user_view || user_activity_log ? (
    <SidebarMenuItemWithSub
    to='/admins'
    title='Admins'
    icon='profile-user'
    fontIcon='bi-person'
  >
    {
      user_create && <SidebarMenuItem to='/admins/add-admin' title='Add Admin' hasBullet={true} />
    }
    {
      user_view && <SidebarMenuItem to='/admins/admins-list' title='List of Admins' hasBullet={true} />
    }
    {
      user_activity_log && <SidebarMenuItem to='/admins/all-logs' title='Logs' hasBullet={true} />
    }
  </SidebarMenuItemWithSub>
  ): null
}
   {
    role_create || role_activity_log || role_view ?(
      <SidebarMenuItemWithSub
      to='/roles'
      title='Roles'
      icon='people'
      fontIcon='bi-person'
    >
      {
        role_create && <SidebarMenuItem to='/roles/add-role' title='Add Role' hasBullet={true} />
      }
      {
        role_view && <SidebarMenuItem to='/roles/roles-list' title='List of Roles' hasBullet={true} />
      }
      {
        role_view && <SidebarMenuItem to='/roles/logs' title='Logs' hasBullet={true} />
      }
    </SidebarMenuItemWithSub>
    ):null
   }
   {
    user_application_create || user_application_activity_log || user_application_view ?(
      <SidebarMenuItemWithSub
        to='/user-applications'
        title='User Applications'
        icon='people'
        fontIcon='bi-person'
      >
        {
          user_application_view && <SidebarMenuItem to='/user-applications/active' title='Active Applications' hasBullet={true} />
        }
        {
          user_application_view && <SidebarMenuItem to='/user-applications/inactive' title='Inactive Applications' hasBullet={true} />
        }
      </SidebarMenuItemWithSub>
    ):null
   }
   {
  user_create || user_view || user_activity_log ? (
    <SidebarMenuItemWithSub
    to='/owner-users'
    title='Owner Users'
    icon='profile-user'
    fontIcon='bi-person'
  >
    {
      user_view && <SidebarMenuItem to='/owner-users/list-users' title='List of Users' hasBullet={true} />
    }
  </SidebarMenuItemWithSub>
  ): null
}
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
